import { combineReducers } from 'redux'
import magazines from './magazines'
import languages from './language'
import user from './user'
import ui from './ui'
import { pages, activePage } from './pages'
import { actualElement, elements } from './elements'
import { textEditors, activeTextEditor } from './textEditors'

export default combineReducers( {
  magazines,
  languages,
  user,
  ui,
  pages,
  activePage,
  actualElement,
  elements,
  textEditors,
  activeTextEditor
} )


// WEBPACK FOOTER //
// ./src/store/reducers/index.js